import styles from "../../../styles/candidate/parts/CandidateInfoSideNavigation.module.scss";

const CandidateInfoSideNavigation = ({ items, selectedKey, onItemSelect }) => {
  const handleOnClick = (key) => {
      onItemSelect(key);
  };

  return (
    <div className={styles.candidateInfoSideNavWrapper}>
      {
        items && items.map((item) => {
          return item.isCategory
            ? <div key={item.key} className={styles.navItemCategory}>
                <a>{item.label || item.issue}</a>
              </div>
            : <div 
                key={item.key} 
                onClick={() => handleOnClick(item.key)} 
                className={
                  selectedKey === item.key
                  ? styles.isActive 
                  : styles.navItem
                }
              >
                <a>{item.label || item.issue}</a>
              </div>
        })
      }
    </div>
  )
};

export default CandidateInfoSideNavigation;
